import qs from 'qs'

interface RouteParams {
  [propName: string]: string | number | RouteParams
}

function getRouteUrl(packageName: string, routeName: string): string {
  return `/${packageName}/pages/${routeName}/index`
}

export async function routerChange(
  changeType: 'reLaunch' | 'redirectTo' | 'navigateTo' | 'switchTab',
  packageName: string,
  routeName: string,
  routeParams: RouteParams = {}
): Promise<void> {
  let url: string = getRouteUrl(packageName, routeName)
  if (Object.keys(routeParams).length) url += `?${qs.stringify(routeParams)}`

  routeStack.push({ packageName, routeName })

  // await uni[changeType]({ url })

  switch (changeType) {
    case 'reLaunch':
      uni.reLaunch({ url })
      break
    case 'redirectTo':
      uni.redirectTo({ url })
      break
    case 'navigateTo':
      uni.navigateTo({ url })
      break
    case 'switchTab':
      uni.switchTab({ url })
      break
  }
}

export async function routerBack(delta: number, value?: any): Promise<void> {
  if (delta < 1) return
  uni.navigateBack({
    delta, success: () => {
      if (value != undefined) {
        const pages = getCurrentPages()
        const prevPage = pages[pages.length - 2]
        console.log(prevPage)
        prevPage._.exposed.onPrevPageCb(value)
      }
      const _routeStack = getCurrentPages().map(it => ({ packageName: it.route.split("/")[0], routeName: it.route.split("/")[2] }))[0]
      routeStack.push(_routeStack)
    }
  })

}

export async function routerBackCustom(packageName: string, routeName: string, isComponentWillUnmount?: boolean): Promise<void> {
  let delta: number = getTargetDelta(packageName, routeName)
  if (isComponentWillUnmount) delta--
  await routerBack(delta)
}

export function getTargetDelta(packageName: string, routeName: string): number {
  const url: string = getRouteUrl(packageName, routeName)
  const routeHistoryList = getCurrentPages()

  const activeIndex: number = routeHistoryList.findIndex(item => url.indexOf(item.route) !== -1)
  if (activeIndex === -1) {
    throw new Error('getTargetDelta 寻找的路由，在路由历史记录中找不到')
  }

  const delta: number = routeHistoryList.length - 1 - activeIndex
  return delta
}

const routeStack: { packageName: string, routeName: string }[] = [{ packageName: 'packageMain', routeName: 'home' }]

export function getPrevChangeRoutes() {
  return routeStack
}
